import { render, staticRenderFns } from "./no-record.vue?vue&type=template&id=a65c4e08&scoped=true&"
import script from "./no-record.vue?vue&type=script&lang=js&"
export * from "./no-record.vue?vue&type=script&lang=js&"
import style0 from "./no-record.vue?vue&type=style&index=0&id=a65c4e08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65c4e08",
  null
  
)

export default component.exports